import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../../authConfig';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Stack, Icon, PrimaryButton, TextField, FocusTrapZone, Spinner } from '@fluentui/react';

const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
const API_URL = process.env.REACT_APP_API_URL;

// Processing dialog style
const spinnerStyles = {
  circle: {
    height: 56,
    width: 56,
    borderWidth: 4,
  },
};

const DynamicsCrmConnect = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const history = useHistory();

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);

  const [status, setStatus] = useState('');

  const [resource, setResource] = useState(sessionStorage.getItem('dynamics-fo-resourceUrl') || '');
  const [clientId, setClientId] = useState(sessionStorage.getItem('dynamics-fo-clientId') || '');
  const [clientSecret, setClientSecret] = useState(sessionStorage.getItem('dynamics-fo-clientSecret') || '');

  const redirectUri = PUBLIC_URL + '/etax/sources/dynamics/finance-operations/connect';
  const oauth2Endpoint = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?scope=${resource}/.default offline_access&response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&client_secret=${clientSecret}`;

  const companyId = sessionStorage.getItem('companyId') || '';

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    window.location.href = oauth2Endpoint;
  };

  useEffect(() => {
    console.log('userEffect retrieve users data!');

    const getSourceData = async () => {
      const query = new URLSearchParams(window.location.search);
      const code = query.get('code');

      if (code) {
        console.log('userEffect retrieve access_token!');
        console.log('Microsoft code: ', code);

        setIsLoading(true);

        instance
          .acquireTokenSilent({ ...silentRequest, account: account })
          .then((tokenResponse) => {
            axios
              .post(
                API_URL + '/sources/dynamics/fo',
                {
                  code: code,
                  clientId: clientId,
                  clientSecret: clientSecret,
                  redirectUri: redirectUri,
                  resourceUrl: resource,
                },
                {
                  headers: {
                    'Authorization': 'Bearer ' + tokenResponse.accessToken,
                    'cid': companyId
                },
                }
              )
              .then(
                (response) => {
                  console.log('Microsoft sources response: ', response);

                  if (response.data) {
                    if (response.data.canLogin) {
                      history.push({
                        pathname: '/etax/sources/dynamics/finance-operations',
                        state: {},
                      });
                    } else {
                      setStatus('fail');
                    }
                  }

                  setIsLoading(false);
                },
                (error) => {
                  console.log(error);
                  setIsLoading(false);
                }
              );
          })
          .catch((error) => {
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);

            setIsLoading(false);
          });
      } else {
        instance
          .acquireTokenSilent({ ...silentRequest, account: account })
          .then((tokenResponse) => {
            axios
              .get(API_URL + '/sources/dynamics-fo', {
                headers: {
                  'Authorization': 'Bearer ' + tokenResponse.accessToken,
                  'cid': companyId
                },
              })
              .then(
                (response) => {
                  console.log('Dynamics FO sources: ', response);

                  if (response.data) {
                    if (!response.data.disabled && response.data.canLogin) {
                      history.push({
                        pathname: '/etax/sources/dynamics/finance-operations',
                        state: {},
                      });
                    }
                  }

                  setIsLoading(false);
                },
                (error) => {
                  console.log(error);
                  setIsLoading(false);
                }
              );
          })
          .catch((error) => {
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            instance.acquireTokenRedirect(silentRequest);

            setIsLoading(false);
          });
      }
    };

    getSourceData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack>
      {!isLoading && (
        <Stack>
          <br />

          <h1 style={{ marginLeft: '0px', marginTop: '27px' }}>
            <Icon iconName="Dynamics365Logo" style={{ color: '#106ebe' }} /> {t('dynamicFoConnect.header')}
          </h1>
          <h3 style={{ marginTop: '0px', marginBottom: '10px', alignSelf: 'center' }}>{t('dynamicFoConnect.subHeader1')}</h3>
          <h3 style={{ marginTop: '0px', marginBottom: '10px', alignSelf: 'center' }}>{t('dynamicFoConnect.subHeader2')}</h3>

          <br />
          <br />
        </Stack>
      )}
      {status === '' && !isLoading && (
        <FocusTrapZone disabled={true}>
          <Stack horizontalAlign="center">
            <Stack
              style={{
                border: '1px solid rgb(134, 134, 134)',
                width: '350px',
                backgroundColor: '#FFFFFF',
              }}
            >
              <br />
              <Stack horizontal horizontalAlign="center">
                <img src="/images/finance-and-operations-logo.png" alt="dynamics-finance-operations" width="250px" style={{ margin: 0 }} />
              </Stack>
              <form onSubmit={handleSubmit}>
                <Stack horizontal horizontalAlign="center">
                  <TextField
                    label="Resource Url"
                    description={t('dynamicFoConnect.resourceUrl')}
                    required
                    onChange={(e) => {
                      setResource(e.target.value);
                      sessionStorage.setItem('dynamics-fo-resourceUrl', e.target.value);
                    }}
                    value={resource}
                    style={{ width: '280px' }}
                  />
                </Stack>
                <br />
                <Stack horizontal horizontalAlign="center">
                  <TextField
                    label="Client Id"
                    required
                    onChange={(e) => {
                      setClientId(e.target.value);
                      sessionStorage.setItem('dynamics-fo-clientId', e.target.value);
                    }}
                    value={clientId}
                    style={{ width: '280px' }}
                  />
                </Stack>

                <Stack horizontal horizontalAlign="center">
                  <TextField
                    label="Client Secret"
                    type="password"
                    canRevealPassword
                    required
                    onChange={(e) => {
                      setClientSecret(e.target.value);
                      sessionStorage.setItem('dynamics-fo-clientSecret', e.target.value);
                    }}
                    value={clientSecret}
                    style={{ width: '250px' }}
                  />
                </Stack>

                <br />
                <br />
                <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: '30px' }}>
                  <PrimaryButton
                    style={{
                      fontSize: '20px',
                      height: '50px',
                      width: '280px',
                    }}
                    type="submit"
                  >
                    {t('dynamicFoConnect.connect')}
                  </PrimaryButton>
                </Stack>
              </form>
              <br />
              <br />
            </Stack>
          </Stack>
        </FocusTrapZone>
      )}
      {isLoading && (
        <Stack>
          <Stack horizontal horizontalAlign="center">
            <br />
            <br />
            <div className="certificates-loading-center">
              {false ? (
                <Spinner label={t('dynamicFoConnect.processing')} labelPosition="down" styles={spinnerStyles} />
              ) : (
                <Spinner label={t('dynamicFoConnect.loading')} labelPosition="down" styles={spinnerStyles} />
              )}
            </div>
            <br />
          </Stack>
        </Stack>
      )}

      {status === 'success' && (
        <Stack horizontal horizontalAlign="center">
          <Stack
            style={{
              border: '1px solid rgb(134, 134, 134)',
              width: '300px',
              backgroundColor: '#FFFFFF',
            }}
          >
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <h1 style={{ margin: '0px', color: '#0078D4' }}>{t('dynamicFoConnect.successMessage')}</h1>
            </Stack>
            <br />
            <Stack horizontal horizontalAlign="center">
              <img height="120" src="/images/success03.gif" alt="success03gif" />
            </Stack>
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <PrimaryButton
                style={{ fontSize: '20px', height: '50px' }}
                onClick={() => {
                  history.push({
                    pathname: '/etax/sources/paypal',
                    state: {},
                  });
                }}
              >
                {t('dynamicFoConnect.successButton')}
              </PrimaryButton>
            </Stack>
            <br />
            <br />
          </Stack>
        </Stack>
      )}

      {status === 'fail' && (
        <Stack horizontal horizontalAlign="center">
          <Stack
            style={{
              border: '1px solid rgb(134, 134, 134)',
              width: '300px',
              backgroundColor: '#FFFFFF',
            }}
          >
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <h1 style={{ margin: '0px', color: '#F25139' }}>{t('dynamicFoConnect.failMessage')}</h1>
            </Stack>
            <br />
            <Stack horizontal horizontalAlign="center">
              <img height="120" src="/images/fail01.gif" alt="fail01gif" />
            </Stack>
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <PrimaryButton
                style={{ fontSize: '20px', height: '50px' }}
                onClick={() => {
                  setStatus('');
                }}
              >
                {t('dynamicFoConnect.failButton')}
              </PrimaryButton>
            </Stack>
            <br />
            <br />
          </Stack>
        </Stack>
      )}

      <br />
      <br />
      {status === '' && !isLoading && (
        <center>
          <br />
          <br />
          <span style={{ color: 'gray' }}>{t('dynamicFoConnect.footer1')}</span>
          <br />
          <br />
          <span style={{ color: 'gray', fontWeight: 'bold' }}>{t('dynamicFoConnect.footer2')}</span>
        </center>
      )}
    </Stack>
  );
};

export default DynamicsCrmConnect;
